export const configs = {
  baseURL: 'https://transport.nham24.com/api/v1/',
  v3BaseURL: 'https://9wsggsimk3.execute-api.ap-southeast-1.amazonaws.com/prod/api/v1/',
  socketBaseURL: 'https://realtime.nham24.com/api/v1/',

  socket: {
    realtimeHost: 'transportation-198bd673-1ac4-4dd4-8714-671c7b0e89bc.go24.workers.dev',
    realtimeAppKey: '1ef15594-02c9-4899-8ae6-0684a1ec39fa',
    realtimeAppId: '34aa57d8-db92-433e-b106-0f70bd2c94e4',
    realtimePost: 443,
    realtimeAppSecret: 'Fu2KPEcKKaE0uOxrxDPeUwh1RlmX9ao6',
  },
};
